import * as ActionTypes from 'constants';

export const fetchContacts = clientId => ({
  type : ActionTypes.FETCH_CONTACTS,
  payload : { clientId }
});

export const clearContacts = f => ({
  type : ActionTypes.CLEAR_CONTACTS
});

export const createContact = contact => ({
  type : ActionTypes.CREATE_CONTACT,
  payload : { contact }
});

export const deleteContact = contact => ({
  type : ActionTypes.DELETE_CONTACT,
  payload : { contact }
})



// WEBPACK FOOTER //
// ./src/common/actions/contacts.js